import { ItemFormFilling,SubItemFormFilling } from "../../types/new-form-filling/types";
import { isValidCpfCnpjFormat } from "../../helpers/cpfCnpj";

const setNaoOk = () => "naoOk";
const setOk = () => "ok";

const regexEmail = /^(?![.-])([A-Za-z0-9._%+-]+(?:(?<=.)[A-Za-z0-9._%+-]))@[A-Za-z0-9.-]+\.[A-Za-z]{1,}$/;

function getLength(value: unknown): number | undefined {
  const valueWithLength = value as { length?: unknown } | null | undefined;
  return typeof valueWithLength?.length === "number" ? valueWithLength.length : undefined;
}

function checkValueLength(value: unknown, expected: number[]): boolean {
  const length = getLength(value);
  return typeof length === "number" && expected.includes(length);
}

export function CheckIconItem(item: ItemFormFilling) {
  if (item.subitens.some((ele) => ele.obrigatoriedade?.preenchimento && !ele.checked)) {
    return setNaoOk();
  }
  if (item.subitens.some((ele) => ele.obrigatoriedade?.preenchimento && ele.checked)) {
    return setOk();
  }
  if (item.subitens.some((ele) => !ele.obrigatoriedade?.preenchimento)) {
    if (item.subitens.every((ele) => !ele.checked)) return "default";
    if (item.subitens.some((ele) => ele.checked)) return setOk();
  }
  return "default";
}

export default function CheckIcon(subItem: SubItemFormFilling, value?: unknown) {
  const obriga = subItem.obrigatoriedade?.preenchimento;

  // ✅ AVALIAÇÃO
  if (subItem.tipo === "avaliacao") {
    if (obriga && typeof subItem.nota !== "number") return setNaoOk();

    const nota = subItem.nota;
    const threshold = subItem.threshold;

    if (typeof nota === "number" && (threshold || threshold === 0)) {
      const status = nota === -1 ? "NA" : nota <= threshold ? "naoConforme" : "conforme";
      const obrig = subItem.obrigatoriedade?.[status];

      if (!subItem.hideImg && obrig?.img && (!subItem.img || subItem.img.length === 0)) return setNaoOk();

      if (!subItem.hideComent && obrig?.ocorrencia && (!subItem.ocorrencia || (subItem.ocorrencia as string)?.length === 0)) return setNaoOk();

      if (obrig?.obrigaArquivo && (!subItem.arquivos || subItem.arquivos.length === 0)) return setNaoOk();

      return setOk();
    }

    return "default";
  }

  // ✅ OBRIGATORIEDADES GERAIS
  if (value && subItem?.obrigatoriedade?.ocorrencia) {
    if (subItem.tipo === "multiple" && value && !subItem.ocorrencia) return setNaoOk();
    if (value && subItem.tipo !== "multiple" && !subItem.obs) return setNaoOk();
  }

  if (value && subItem?.obrigatoriedade?.img && (!subItem.img || subItem.img.length === 0)) {
    return setNaoOk();
  }

  if (subItem?.obrigatoriedade?.obrigaArquivo && (!subItem.arquivos || subItem.arquivos.length === 0)) {
    return setNaoOk();
  }

  // ✅ TIPOS ESPECIAIS
  switch (subItem?.tipo) {
    case "unique":
    case "multiple":
    case "list":
    case "textoCurto":
    case "valorMedida":
    case "textoLongo":
    case "assinatura":
      if (obriga && (!value || (Array.isArray(value) && value.length === 0))) return setNaoOk();
      return value ? setOk() : "default";
    case "hora":
    case "data":
      if (obriga && (!value || (value instanceof Date && isNaN(value.getTime())))) return setNaoOk();
      return value ? setOk() : "default";
    case "numero":
      const valNum = value as number;

      if (obriga && (!valNum && valNum !== 0)) return setNaoOk();

      if (subItem.maxNumberVal !== undefined && valNum > subItem.maxNumberVal) return setNaoOk();
      if (subItem.minNumberVal !== undefined && valNum < subItem.minNumberVal) return setNaoOk();

      return setOk();

    case "rg":
      if (obriga && getLength(value) !== 12) return setNaoOk();
      return getLength(value) === 12 ? setOk() : "default";

    case "email":
      if (obriga && !regexEmail.test(String(value))) return setNaoOk();
      return value && regexEmail.test(String(value)) ? setOk() : "default";

    case "cpfcnpj":
      if (obriga && !isValidCpfCnpjFormat(value as string)) return setNaoOk();
      return isValidCpfCnpjFormat(value as string) ? setOk() : "default";

    case "cep":
      if (obriga && getLength(value) !== 9) return setNaoOk();
      return getLength(value) === 9 ? setOk() : "default";

    case "telefone":
      if (obriga && !checkValueLength(value, [12, 13])) return setNaoOk();
      return checkValueLength(value, [12, 13]) ? setOk() : "default";

    case "placa":
      if (obriga && getLength(value) !== 8) return setNaoOk();
      return getLength(value) === 8 ? setOk() : "default";

    default:
      return value ? setOk() : "default";
  }
}
